module.exports = __webpack_public_path__ + "static/media/weaknessDetailTitle.633ab77c.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/weaknessDetailTitle.png
// module id = 1505
// module chunks = 0